/**
 * Espande i token globali in una stringa HTML, sostituendoli con il contenuto
 * configurato su WordPress (ACF Options "Privacy").
 *
 * Token gestiti:
 * - @@privacy@@        → testo completo dell'informativa (CORPO dei popup,
 *   HTML da WYSIWYG);
 * - @@privacy-title@@  → titolo breve dedicato (TITOLO dei popup, vedi
 *   ModalService).
 *
 * Sostituzione puramente testuale (stessa logica di `runtimeBankNameReplacer`
 * per @@nome-banca@@): il risultato va poi passato a `parse()` di html-react-parser.
 * Nota: `@@privacy@@` non è substring di `@@privacy-title@@`, quindi i token non
 * collidono e l'ordine di sostituzione è ininfluente.
 *
 * Accorgimenti per evitare HTML "sporco" tipico del WYSIWYG (rilevanti solo per
 * il token "corpo", il token "title" è testo semplice):
 * - se il token è da solo dentro un <p> (es. "<p>@@privacy@@</p>", anche con
 *   spazi/&nbsp;/<br>) il wrapper <p> viene rimosso, così non si annida il
 *   contenuto iniettato dentro un paragrafo (nesting non valido);
 * - dopo l'iniezione si rimuovono i paragrafi vuoti (es. <p></p>, <p>&nbsp;</p>)
 *   che il WYSIWYG lascia spesso in testa al testo incollato.
 *
 * @param {string} html  Contenuto del popup (HTML o, per i titoli, testo).
 * @param {{privacy?: string, privacyTitle?: string}} contents  Valori da iniettare.
 * @returns {string} HTML con i token espansi.
 */
export function expandGlobalTokens(html, { privacy, privacyTitle } = {}) {
  if (!html || typeof html !== "string") {
    return html;
  }

  let out = html;
  let injected = false;

  if (privacy && out.includes("@@privacy@@")) {
    out = out
      .replace(
        /<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*@@privacy@@(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi,
        privacy
      )
      .split("@@privacy@@")
      .join(privacy);
    injected = true;
  }

  if (privacyTitle && out.includes("@@privacy-title@@")) {
    out = out.split("@@privacy-title@@").join(privacyTitle);
  }

  if (injected) {
    out = out.replace(/<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "");
  }

  return out;
}
